/**
 *
 */

import { z } from "zod";

const schemaModelo = z.object({
  cliente: z.string().min(1, "Cliente é obrigatório"),
  produto: z.string().min(1, "Selecione um produto"),
  nomeModelo: z.string().min(1, "Nome do modelo é obrigatório"),
  fotoModelo: z.instanceof(FileList).optional(),
  temFuro: z.boolean().optional().default(false),
  posicionamento: z.enum(["Horizontal", "Vertical"]),
  tipoFuro: z.string().optional(),
  temCargaFotos: z.boolean().optional().default(false),
  temDadosVariaveis: z.boolean().optional().default(false),
  isProvisorio: z.boolean().optional().default(false),
  campoChave: z.string().optional(),
  observacoes: z.string().optional(),
});

type FormDataEditModel = z.infer<typeof schemaModelo>;

/**
 * EXPORTS
 */
export type { FormDataEditModel };
export { schemaModelo };
